// Simple Service Worker Registration for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[SW] Registered successfully');
        
        // Check for updates periodically
        setInterval(() => registration.update(), 60 * 60 * 1000); // Every hour
      })
      .catch((error) => {
        console.error('[SW] Registration failed:', error);
      });
  });
}

// Utility function to manually clear caches
window.clearPWACaches = function() {
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        console.log('Clearing cache:', name);
        caches.delete(name);
      });
    });
  }
  
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
  }
  
  console.log('Cache cleared. Refresh the page.');
};

// Emergency reset - unregister service worker completely
window.resetPWA = function() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => {
        console.log('Unregistering:', reg.scope);
        reg.unregister();
      });
    });
  }
  
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }
  
  console.log('PWA reset complete. Refresh the page.');
};
